import React, { useMemo, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Stepper } from "@shared/components/Stepper";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { SharedAccountSelection } from "../shared/sharedAccountSelection";
import { NoticeDetails } from "./stepComponents/noticeDetails/noticeDetails";
import { SharedReviewSend } from "../shared/sharedReviewSend";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@shared/components/PageHeader";

export const BulkNoticeCreate: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const remoteUtilityId = useRemoteUtilityId();
  const storageKey = `bulk-notice-wizard-progress-${remoteUtilityId}`;

  // Clear stepper progress ONLY when navigating away from the page
  useEffect(() => {
    return () => {
      if (window.location.pathname !== "/cx/outstanding/create/bulk-notice") {
        localStorage.removeItem(storageKey);
      }
    };
  }, [location.pathname, storageKey]);

  // Pre-load steps definition
  const steps = useMemo(
    () => [
      {
        title: "Select Consumers",
        slug: "select-consumers",
        component: (
          <SharedAccountSelection type="notice" storageKey={storageKey} />
        ),
        optional: false,
      },
      {
        title: "Notice Details",
        slug: "notice-details",
        component: <NoticeDetails />,
        optional: false,
      },
      {
        title: "Review & Send",
        slug: "review-send",
        component: <SharedReviewSend type="notice" />,
        optional: false,
      },
    ],
    [storageKey],
  );

  if (!remoteUtilityId) {
    return (
      <div className="flex items-center justify-center p-12 bg-white border border-gray-200 rounded-xl shadow-sm">
        <div className="animate-pulse text-gray-500 font-semibold text-sm">
          Loading configuration...
        </div>
      </div>
    );
  }
  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      {/* Wizard Header bar */}
      <div className="flex items-center justify-between pb-4">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              localStorage.removeItem(storageKey);
              navigate("/cx/outstanding");
            }}
          >
            <ArrowLeft size={16} />
          </Button>
          <PageHeader
            title="New Bulk Notice Request"
            subtitle="Outstanding account balance batch collections setup"
          />
        </div>
      </div>

      <div className="bg-white p-6 border border-gray-200 rounded-xl shadow-sm">
        <Stepper
          steps={steps}
          onStepChange={() => {}}
          onStepSave={async () => {}}
          enableApiSave={false}
          saveOnStepChange={false}
          trackDirtyState={false}
          autoSave={true}
          persistProgress={true}
          allowSkip={false}
          storageKey={storageKey}
          enableRouting={true}
          onValidation={undefined}
          showDraftResume={false}
        />
      </div>
    </div>
  );
};

export default BulkNoticeCreate;
